import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';



import {Toaster} from "react-hot-toast";
import AuthProvider, {AuthContext} from "./services/auth.service";
import DataProvider from "./services/data.service";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import HomePage from "./pages/Home";
import Layout from "./components/Layout";
import PrivateRoute from "./js/router/PrivateRoute";
import DatasetsPage from "./pages/Datasets";
import GroundTruthEditorPage from "./pages/GroundTruth";
import {RedirectWithSearch} from "./js/router/helpers";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <AuthProvider>
            <DataProvider>
                <BrowserRouter>
                    <Layout>
                        <AuthContext.Consumer>
                            {auth =>
                                <Routes>
                                    <Route index element={<HomePage/>}/>
                                        <Route element={<PrivateRoute isAllowed={!!auth.user}/>}>
                                            <Route path="/datasets" element={<DatasetsPage/>} />
                                            <Route path="/editor*" element={<GroundTruthEditorPage/>}/>
                                            <Route
                                                path="/annotator*"
                                                element={<RedirectWithSearch to="/editor" />}
                                            />
                                        </Route>
                                </Routes>
                            }
                        </AuthContext.Consumer>
                    </Layout>
                </BrowserRouter>
            </DataProvider>
        </AuthProvider>
        <Toaster/>
    </>
);

